import Vue from 'vue'
import BFormGroup from 'b-form-group'
import Vuemerang from 'vuemerang'
import 'vuemerang/dist/vuemerang.css'
import ManageRFC from '../store/manageRFC'

const manageRFC = new ManageRFC()
const theme = manageRFC.state.theme

Vue.use(BFormGroup)
Vue.use(Vuemerang,
  theme
)
